import {TabPane} from "element-ui"

export default {
  extends: TabPane,
  data() {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/ni-ui/tabs/tab-pane/tab-pane.js